import { SofiaEnvironment } from "@/sofia-environment"

const {
  Bff: { Url: bffHost, Credentials: credentials },
} = SofiaEnvironment

const hinEpdLoginUrl = `${bffHost}/bff/hin-epd-login?returnUrl=/hin-epd-logged-in`

const hinEpdLogin = () => window.open(hinEpdLoginUrl)

const hinEpdLogout = async () => {
  const response = await fetch(`${bffHost}/bff/hin-epd-logout`, {
    method: "DELETE",
    credentials: credentials,
  })

  if (!response.ok) {
    throw new Error("Failed to logout for E-Rezept")
  }
}

const hinEpdCheckValidity = async () => {
  const response = await fetch(`${bffHost}/bff/hin-epd-silent-login`, {
    method: "GET",
    credentials: credentials,
  })

  return response.status === 200
}

export { hinEpdLoginUrl, hinEpdLogin, hinEpdLogout, hinEpdCheckValidity }
